var _path, _rect, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999938 14C0.999937 6.82169 6.82805 1.00001 14.0205 1.00001C21.2129 1 27.041 6.82168 27.041 14C27.041 21.1783 21.2129 27 14.0205 27C6.82805 27 0.999938 21.1783 0.999938 14Z",
    stroke: "#A3A3A3",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.8086,
    y: 9.27002,
    width: 6.44444,
    height: 8.2963,
    fill: "#4E4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3905 13.1211L23.3685 8.68445L28.5874 8.19078L26.3905 13.1211Z",
    fill: "#A3A3A3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3053_4240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6149 19.5363L13.2909 20.5997L7.9668 19.5363L7.9668 10.7983L13.2909 11.5231L18.6149 10.7983L18.6149 19.5363Z",
    fill: "#4E4E4E",
    stroke: "#A3A3A3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2793 11.6023L15.1051 13.2437L20.284 12.1667L18.6891 10.7668L13.2793 11.6023Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2793 11.6023L15.1051 13.2437L20.284 12.1667L18.6891 10.7668L13.2793 11.6023",
    stroke: "#A3A3A3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03308 10.6348L6.57227 12.2717L11.3933 13.3397L13.343 11.6282L7.9242 10.6811",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03308 10.6348L6.57227 12.2717L11.3933 13.3397L13.343 11.6282L7.9242 10.6811",
    stroke: "#A3A3A3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3207 20.6156L13.2773 11.6406",
    stroke: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05664 10.3706L13.427 9.85205L18.7974 10.3706",
    stroke: "#A3A3A3",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3053_4240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.963,
    height: 15.5556,
    fill: "white",
    transform: "translate(6.44531 5.1853)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateProduct);
export default __webpack_public_path__ + "static/media/update-product.c766725ccc2ca62fb61e74412d9f2abc.svg";
export { ForwardRef as ReactComponent };